import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpersService } from '../../../../core/services/helpers.service';
import { TeamService } from '../../../../core/api/team.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../../components/confirm-dialog/confirm-dialog.component';
import { LoadingService } from '../../../../core/services/loading.service';

@Component({
  selector: 'app-action-team',
  standalone: true,
  imports: [CommonModule, MatSelectModule, FormsModule, ReactiveFormsModule],
  templateUrl: './action-team.component.html',
  styleUrl: './action-team.component.scss',
})
export class ActionTeamComponent {
  m: any;
  id: any;
  form: FormGroup;

  constructor(
    private activatedRoute: ActivatedRoute,
    private helpers: HelpersService,
    private fb: FormBuilder,
    private router: Router,
    private teamService: TeamService,
    private dialog: MatDialog,
    private loadingService: LoadingService
  ) {
    this.m = this.activatedRoute.snapshot.queryParams['m'];
    this.id = this.activatedRoute.snapshot.queryParams['id'];
    this.form = this.fb.group({
      name: [null, [Validators.required]],
      description: [null, [Validators.required]],
      expanse_categories: [[]],
    });
  }

  ngOnInit(): void {
    this.getDataById().catch((error) => {
      this.helpers.sbError('Terjadi kesalahan saat memuat data.');
    });
  }

  getDataById(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.id) {
        this.loadingService.startLoading();
        this.teamService.getById(this.id).then(
          (data) => {
            this.loadingService.endLoading();
            this.form.patchValue(data);
            resolve();
          },
          (error) => {
            this.loadingService.endLoading();
            this.helpers.sbError(error.message);
            reject(error);
          }
        );
      } else {
        resolve();
      }
    });
  }

  submit(): void {
    if (this.form.valid) {
      this.dialog
        .open(ConfirmDialogComponent, {
          width: '545px',
          maxHeight: '95vh',
          panelClass: 'confirm-dialog',
          data: {
            title: `Confirm ${this.m == 'add' ? 'Add New Team' : 'Edit Team'}`,
            message: `Changes to the team cannot be undone once saved. Are you sure you want to proceed?`,
          },
        })
        .afterClosed()
        .subscribe((result: any) => {
          if (result) {
            this.loadingService.startLoading();
            const actionPromise =
              this.m == 'add'
                ? this.teamService.insert(this.form.value)
                : this.teamService.updateById(this.id, this.form.value);

            actionPromise
              .then(() => {
                this.loadingService.endLoading();
                this.helpers.sbSuccess(
                  `Team berhasil ${
                    this.m == 'add' ? 'ditambahkan' : 'diperbarui'
                  }!`
                );
                this.router.navigate(['/dashboard/team']);
              })
              .catch((error) => {
                this.loadingService.endLoading();
                this.helpers.sbError(error.message);
              });
          }
        });
    } else {
      this.helpers.sbError('Lengkapi form terlebih dahulu!');
    }
  }

  cancel() {
    this.router.navigate(['/dashboard/team']);
  }
}
